import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ISagaCb } from '@typings/requestPayloads'

export interface IMeetingCostsPayloadState extends ISagaCb {}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const meetingCostsSlice = createSlice({
    name: 'meeting-statistics/meetign-costs',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IMeetingCostsPayloadState>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const meetingCostsActions = meetingCostsSlice.actions
export default meetingCostsSlice.reducer
